var map = {
	"./bold-icon.svg": "7d45",
	"./code-block-icon.svg": "bb39",
	"./code-icon.svg": "573a",
	"./hr-icon.svg": "2400",
	"./img-icon.svg": "6197",
	"./italic-icon.svg": "c5d5",
	"./link-icon.svg": "a2a2",
	"./ol-icon.svg": "99ac",
	"./paragraph-icon.svg": "5889",
	"./quote-icon.svg": "ddd8",
	"./redo-icon.svg": "016f",
	"./strikethrough-icon.svg": "1178",
	"./table-addca-icon.svg": "542a",
	"./table-addcb-icon.svg": "edd4",
	"./table-addra-icon.svg": "b03b",
	"./table-addrb-icon.svg": "2c87",
	"./table-delc-icon.svg": "8e4a",
	"./table-delete-icon.svg": "b0413",
	"./table-delr-icon.svg": "8430",
	"./table-icon.svg": "f177",
	"./table-merge-icon.svg": "1460",
	"./ul-icon.svg": "10d3",
	"./underline-icon.svg": "0954",
	"./undo-icon.svg": "c973",
	"./video-icon.svg": "b778"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b39c";